
import { mapState, mapGetters } from 'vuex';
import ReviewScore from '@/enums/ReviewScore';

export default {
  name: 'AppHeaderV2ProductScore',
  props: {
    useOnlyScore: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState('productScoreSummary', ['scoresMap']),
    ...mapState('reviewSettings', ['reviewSettings']),
    ...mapState('review', ['totalReviewsCount']),
    ...mapGetters('widget', ['device']),
    ...mapGetters('productScoreSummary', [
      'scoredReviewsCount',
      'averageScoreText'
    ]),
    starColor() {
      return { '--star-color': this.reviewSettings.star_color };
    },
    starSize() {
      return this.device === 'pc' ? 36 : this.useOnlyScore ? 28 : 20;
    },
    scoreSummary() {
      return Object.values(this.scoresMap).reverse();
    },
    mostSelectedScoreCount() {
      return Math.max(...this.scoreSummary);
    },
    mostSelectedScore() {
      const scoreNum = parseInt(
        Object.entries(this.scoresMap).find(
          ([_, value]) => value === this.mostSelectedScoreCount
        )[0]
      );

      return ReviewScore.t(scoreNum);
    },
    percentage() {
      return `${Math.round(
        (this.mostSelectedScoreCount / this.scoredReviewsCount) * 100
      )}%`;
    },
    score() {
      return this.scoredReviewsCount > 0 ? this.averageScoreText : '-';
    }
  }
};
